import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MaterialDesignContent } from 'notistack';

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(({theme}) => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: theme.palette.success['600'],
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: theme.palette.error.dark,
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: alpha(theme.palette.info.main, 0.9),
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: theme.palette.warning.main,
  },
}));

export const InfoIcon = styled(InfoOutlinedIcon)`
  margin-right: 8px;
  font-size: 20px;
`;
